/**
 * Keyed JSON-LD injection. Each caller owns a `key`; setting a key replaces only
 * its own <script> tags, so route-level schema (SeoTags) and page-level schema
 * (e.g. FAQPage) never clobber each other. Prerender bakes these into the HTML.
 */

const ATTR = "data-jsonld-key";

export function setStructuredData(key, data) {
  if (typeof document === "undefined" || !key) return;
  clearStructuredData(key);
  const items = (Array.isArray(data) ? data : [data]).filter(Boolean);
  items.forEach((obj) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute(ATTR, key);
    script.text = JSON.stringify(obj);
    document.head.appendChild(script);
  });
}

export function clearStructuredData(key) {
  if (typeof document === "undefined" || !key) return;
  document.head
    .querySelectorAll(`script[${ATTR}="${key}"]`)
    .forEach((el) => el.remove());
}
